import { SEARCH_PROPERTY_STATUS_FOR_SALE_VALUE } from '../types';

export const isPropertyStatusForSale = (status: string | undefined): boolean =>
  status === SEARCH_PROPERTY_STATUS_FOR_SALE_VALUE;
